import { styled } from "@mui/styles";

export const ContentPageControl = styled("div")({
  height: "calc(100% - 56px)",
});
